import React from 'react';
import {Input, Modal, Table} from 'antd';
import IconTip from '../IconTip';
import {FormattedMessage, injectIntl} from 'react-intl';

class MeetingAgenda extends React.Component {
  constructor() {
    super();
    this.state = {
      editRowId: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.inputRef) {
      const input = this.inputRef.refs.input;
      input.focus();
      // input.setSelectionRange(0, input.value.length);
    }
  }

  render() {
    const {dispatch, meetingAgenda, meeting, intl} = this.props;
    const {editRowId} = this.state;
    let columns = [
      {
        title: intl.formatMessage({id: "meeting_sign_label_sign_time"}),
        width: this.props.viewOnly ? '33%' : '25%',
        key: 'time',
        render: record => {
          if (record.id + '_time' == editRowId) {
            return (
              <Input
                maxLength={80}
                className={'input-edit'}
                defaultValue={record.time}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this.setState({editRowId: ''});
                }}
                onChange={e => {
                  meetingAgenda.map(item => {
                    if (item.id == record.id) {
                      item.time = e.target.value;
                    }
                  });
                  dispatch({type: 'set', payload: {meetingAgenda}});
                }}
              />
            );
          } else {
            return (
              <div
                style={{width: '100%', minHeight: '28px', lineHeight: '28px'}}
                onClick={() => {
                  this.setState({editRowId: record.id + '_time'});
                }}
              >
                <span>{record.time}</span>
              </div>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: "topic"}),
        width: this.props.viewOnly ? '33%' : '25%',
        key: 'title',
        render: record => {
          if (record.id + '_title' == editRowId) {
            return (
              <Input
                maxLength={80}
                className={'input-edit'}
                defaultValue={record.title}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this.setState({editRowId: ''});
                }}
                onChange={e => {
                  meetingAgenda.map(item => {
                    if (item.id == record.id) {
                      item.title = e.target.value;
                    }
                  });
                  dispatch({type: 'set', payload: {meetingAgenda}});
                }}
              />
            );
          } else {
            return (
              <div
                style={{width: '100%', minHeight: '28px', lineHeight: '28px'}}
                onClick={() => {
                  this.setState({editRowId: record.id + '_title'});
                }}
              >
                <span>{record.title}</span>
              </div>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: "meeting_agenda_speaker"}),
        width: this.props.viewOnly ? '33%' : '25%',
        key: 'user',
        render: record => {
          let this_ = this;
          if (record.id + '_user' == editRowId) {
            return (
              <Input
                maxLength={80}
                className={'input-edit'}
                defaultValue={record.user}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this_.setState({editRowId: ''});
                }}
                onChange={e => {
                  meetingAgenda.map(item => {
                    if (item.id == record.id) {
                      item.user = e.target.value;
                    }
                  });
                  dispatch({type: 'set', payload: {meetingAgenda}});
                }}
              />
            );
          } else {
            return (
              <div
                style={{width: '100%', minHeight: '28px', lineHeight: '28px'}}
                onClick={() => {
                  this.setState({editRowId: record.id + '_user'});
                }}
              >
                <span>{record.user}</span>
              </div>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: "meeting_list_table_operate"}),
        width: this.props.viewOnly ? '33%' : '25%',
        render: record => {
          return (
            <div>
              <span
                className="operate_del"
                onClick={() => {
                  let newMeetingAgenda = meetingAgenda.filter(
                    ma => ma.id != record.id
                  );
                  dispatch({
                    type: 'meetingInfo/set',
                    payload: {meetingAgenda: newMeetingAgenda}
                  });
                }}
              >
                <IconTip title="删除" type="shanchu"/>
              </span>
            </div>
          );
        }
      }
    ];
    if (this.props.viewOnly) {
      columns.length = columns.length - 1;
    }
    return (
      <div className="meeting_agenda">
        <div className="agenda_table">
          {this.props.viewOnly ? null : (
            <div className="button_div">
              <div
                className="button_add"
                onClick={() => {
                  let newRow = {
                    id: '_' + Math.random(),
                    title: '',
                    user: '',
                    time: ''
                  };
                  dispatch({
                    type: 'meetingInfo/set',
                    payload: {meetingAgenda: meetingAgenda.concat([newRow])}
                  });
                  this.setState({editRowId: newRow.id + '_time'});
                }}
              >
                {' '}
                + <FormattedMessage id="add"/>
              </div>
              <div
                className="meeting_button button_save"
                onClick={() => {
                  if (meeting && meeting.type != 0) {
                    Modal.confirm({
                      content: '是否将该议程同步到其余未开始的会议？',
                      okText: '是',
                      onOk: function () {
                        dispatch({
                          type: 'meetingInfo/saveAgenda',
                          payload: {type: 1}
                        });
                      },
                      cancelText: '否',
                      onCancel: function () {
                        dispatch({
                          type: 'meetingInfo/saveAgenda',
                          payload: {type: 0}
                        });
                      }
                    });
                    this.setState({editRowId: ''});
                  } else {
                    dispatch({
                      type: 'meetingInfo/saveAgenda',
                      payload: {type: 0}
                    });
                  }
                }}
              >
                <FormattedMessage id="btn_save"/>
              </div>
            </div>
          )}
          <Table
            bordered
            className="meeting_agenda_table_wrap"
            rowKey={record => record.id}
            dataSource={meetingAgenda}
            columns={columns}
            pagination={false}
            disabled={this.props.viewOnly}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(MeetingAgenda);



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingAgenda.js